<template>
  <div>
    <ul class="sm:flex sm:justify-center sm:flex-wrap">
      <li
        v-for="(item, index) in content.corridors"
        :key="index"
        class="bg-gray-100 hover:bg-gray-200 rounded-16 py-2 px-4 m-1"
      >
        <a v-if="item" :href="item.url" class="flex align-middle">
          <i :class="`flag flag-${item.countryFrom.iso.toLowerCase()}`" />
          <span
            v-html="
              $t('send_money_from_to', {
                from: item.countryFrom.labels.from,
                to: item.countryTo.labels.to,
              })
            "
            class="text-12"
          />
        </a>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import type { GQLCorridorsListSlice } from './generated/corridors-list'
defineProps<{ content: GQLCorridorsListSlice }>()
</script>
